import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取广告列表 get
 * @param query 分页参数
 * @return request
 * */
export function getAdvertiseList(query) {
    return request({
        url: `${baseURL.businessApi}/advertises`,
        method: 'get',
        params: query
    })
}

/**
 * 增加广告 post
 * @param data 增加的数据
 * @return request
 * */
export function addAdvertise(data) {
    return request({
        url: `${baseURL.businessApi}/advertises`,
        method: 'post',
        data: data
    })
}

/**
 * 删除广告  delete
 * @param id 广告id
 * @return request
 * */
export function deleteAdvertise(id) {
    return request({
        url: `${baseURL.businessApi}/advertises/${id}`,
        method: 'delete'
    })
}

/***
 * 修改广告 Post
 * @param id 要修改的广告id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateAdvertise(id, data) {
    return request({
        url: `${baseURL.businessApi}/advertises/${id}`,
        method: 'post',
        data: data
    })
}